// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
/* App.css */
:root {
  --background-color: #ffffff;
  --text-color: #333333;
  --header-background-color: #ffffff;
  --input-background-color: #f2f2f2;
  --button-color: #4a4a4a;
  --user-message-background: #d3d3d3;
  --assistant-message-background: #f9f9f9;
  --hover-background-color: #e0e0e0; 
  --hover-text-color: #333333;
  --table-background-color: white;
  --table-border-color: #dddddd;
  --table-header-bg-color: #f0f0f0;
  --table-row-alt-bg: #f9fafb;
  --table-hover-bg: #f3f4f6;
  --menu-background: #fff;  /* White background */
  --menu-text-color: #222;  /* Dark text */
  --menu-hover-bg: rgba(0, 0, 0, 0.05); /* Slight gray hover */
  --border-color: #ddd;
  --hover-background: rgba(0, 0, 0, 0.05);
  --banner-background: rgba(0, 0, 0, 0.05);
  --banner-text: #333;
  --info-bg: #ddd;
  --info-text: #555;
  --info-hover-bg: #bbb;
  --code-bg: #f4f4f4;
  --code-text: #1e1e1e;
}

[data-theme='dark'] {
  --background-color: #1e1e1e;
  --text-color: #e0e0e0;
  --header-background-color: #333333;
  --input-background-color: #2e2e2e;
  --button-color: #d3d3d3;
  --user-message-background: #2f2f2f;
  --assistant-message-background: #444444;
  --hover-background-color: #555555; 
  --hover-text-color: #e0e0e0; 
  --table-background-color: #2a2a2a;
  --table-border-color: #555555;
  --table-header-bg-color: #444444;
  --table-row-alt-bg: #3a3a3a;
  --table-hover-bg: #4a4a4a;
  --menu-background: #222; /* Dark background */
  --menu-text-color: #fff; /* Light text */
  --menu-hover-bg: rgba(255, 255, 255, 0.1); /* Slight light hover */
  --border-color: #444;
  --hover-background: rgba(255, 255, 255, 0.1);
  --banner-background: rgba(255, 255, 255, 0.1);
  --banner-text: #fff;
  --info-bg: #444;
  --info-text: #ccc;
  --info-hover-bg: #666;
  --code-bg: #2d2d2d;
  --code-text: #f8f8f2;
}



body, html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  height: 100%;
  background-color: var(--background-color);
  color: var(--text-color);
  overflow: hidden;
}


.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw; 
  overflow: hidden; 
  background-color: var(--background-color);
  color: var(--text-color);
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  background-color: var(--background-color);
  margin: 0 auto;
  max-width: 780px;
  width: 100%;
  overflow: hidden;
}
/* Simple overlay for your pop-up (in App.css, for example) */
.chat-style-banner {
  position: fixed;
  /* near the top, about 15px down so it’s not flush with the browser edge */
  top: 15px;
  /* center it horizontally */
  left: 50%;
  transform: translateX(-50%);

  /* ChatGPT’s red alert color, or pick your own (#f44336 is a common red) */
  background-color: #f44336;
  /* White text */
  color: #fff;
  
  /* Add some padding, a slight border-radius, and a shadow */
  padding: 8px 16px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  
  /* Make the text bold but not huge */
  font-weight: 500;
  font-size: 14px;
  text-align: center;

  /* keep it on top of everything else */
  z-index: 9999;
}

.back-to-dashboard-button:disabled {
  pointer-events: none;    /* Prevent clicks */
  opacity: 0.5;            /* Dim the button visually */
  cursor: not-allowed;     /* Show a blocked cursor */
}




`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ,YAAY;AACZ;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB,GAAG,qBAAqB;EAC/C,uBAAuB,GAAG,cAAc;EACxC,oCAAoC,EAAE,sBAAsB;EAC5D,oBAAoB;EACpB,uCAAuC;EACvC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB,EAAE,oBAAoB;EAC7C,uBAAuB,EAAE,eAAe;EACxC,yCAAyC,EAAE,uBAAuB;EAClE,oBAAoB;EACpB,4CAA4C;EAC5C,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;;;AAIA;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA,6DAA6D;AAC7D;EACE,eAAe;EACf,0EAA0E;EAC1E,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,2BAA2B;;EAE3B,0EAA0E;EAC1E,yBAAyB;EACzB,eAAe;EACf,WAAW;;EAEX,2DAA2D;EAC3D,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;;EAExC,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;EAElB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,oBAAoB,KAAK,mBAAmB;EAC5C,YAAY,aAAa,4BAA4B;EACrD,mBAAmB,MAAM,0BAA0B;AACrD","sourcesContent":["/* App.css */\n/* App.css */\n:root {\n  --background-color: #ffffff;\n  --text-color: #333333;\n  --header-background-color: #ffffff;\n  --input-background-color: #f2f2f2;\n  --button-color: #4a4a4a;\n  --user-message-background: #d3d3d3;\n  --assistant-message-background: #f9f9f9;\n  --hover-background-color: #e0e0e0; \n  --hover-text-color: #333333;\n  --table-background-color: white;\n  --table-border-color: #dddddd;\n  --table-header-bg-color: #f0f0f0;\n  --table-row-alt-bg: #f9fafb;\n  --table-hover-bg: #f3f4f6;\n  --menu-background: #fff;  /* White background */\n  --menu-text-color: #222;  /* Dark text */\n  --menu-hover-bg: rgba(0, 0, 0, 0.05); /* Slight gray hover */\n  --border-color: #ddd;\n  --hover-background: rgba(0, 0, 0, 0.05);\n  --banner-background: rgba(0, 0, 0, 0.05);\n  --banner-text: #333;\n  --info-bg: #ddd;\n  --info-text: #555;\n  --info-hover-bg: #bbb;\n  --code-bg: #f4f4f4;\n  --code-text: #1e1e1e;\n}\n\n[data-theme='dark'] {\n  --background-color: #1e1e1e;\n  --text-color: #e0e0e0;\n  --header-background-color: #333333;\n  --input-background-color: #2e2e2e;\n  --button-color: #d3d3d3;\n  --user-message-background: #2f2f2f;\n  --assistant-message-background: #444444;\n  --hover-background-color: #555555; \n  --hover-text-color: #e0e0e0; \n  --table-background-color: #2a2a2a;\n  --table-border-color: #555555;\n  --table-header-bg-color: #444444;\n  --table-row-alt-bg: #3a3a3a;\n  --table-hover-bg: #4a4a4a;\n  --menu-background: #222; /* Dark background */\n  --menu-text-color: #fff; /* Light text */\n  --menu-hover-bg: rgba(255, 255, 255, 0.1); /* Slight light hover */\n  --border-color: #444;\n  --hover-background: rgba(255, 255, 255, 0.1);\n  --banner-background: rgba(255, 255, 255, 0.1);\n  --banner-text: #fff;\n  --info-bg: #444;\n  --info-text: #ccc;\n  --info-hover-bg: #666;\n  --code-bg: #2d2d2d;\n  --code-text: #f8f8f2;\n}\n\n\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  font-family: Arial, sans-serif;\n  height: 100%;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  overflow: hidden;\n}\n\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw; \n  overflow: hidden; \n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 50px);\n  background-color: var(--background-color);\n  margin: 0 auto;\n  max-width: 780px;\n  width: 100%;\n  overflow: hidden;\n}\n/* Simple overlay for your pop-up (in App.css, for example) */\n.chat-style-banner {\n  position: fixed;\n  /* near the top, about 15px down so it’s not flush with the browser edge */\n  top: 15px;\n  /* center it horizontally */\n  left: 50%;\n  transform: translateX(-50%);\n\n  /* ChatGPT’s red alert color, or pick your own (#f44336 is a common red) */\n  background-color: #f44336;\n  /* White text */\n  color: #fff;\n  \n  /* Add some padding, a slight border-radius, and a shadow */\n  padding: 8px 16px;\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  \n  /* Make the text bold but not huge */\n  font-weight: 500;\n  font-size: 14px;\n  text-align: center;\n\n  /* keep it on top of everything else */\n  z-index: 9999;\n}\n\n.back-to-dashboard-button:disabled {\n  pointer-events: none;    /* Prevent clicks */\n  opacity: 0.5;            /* Dim the button visually */\n  cursor: not-allowed;     /* Show a blocked cursor */\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
